import { call, put, all, takeEvery } from "redux-saga/effects";
import {
  FETCH_OTHERMEDIA_INFO
} from "./actionTypes"
import {
  fetchOtherMediaInfoSuccess
} from "./actions";

import { makeAjax, url, showMessage } from "../../helpers/global_helper";
import { USER_MS_EXT } from "../../helpers/url_helper";

function* fetchOtherMediaInfo(data) {
  try {
    const response = yield call(
      makeAjax,
      url.USER_API.getUserAppOtherMedia,
      data.payload,
      USER_MS_EXT
    );
    if (response.status == 'SUCCESS') {
      yield all([
        put(fetchOtherMediaInfoSuccess({ response: response.data }))
      ]);
    }
    else {
      showMessage(response);
    }
  } catch (error) {
    showMessage(error);
    
    // alert
  }
}

function* othermediaInfomationSaga() {
  yield takeEvery(FETCH_OTHERMEDIA_INFO, fetchOtherMediaInfo);
}

export default othermediaInfomationSaga;
